import { MissionStep } from '@src/features/order/pages/upsert-mission-page/entities';
import { IUpsertMissionInitialState, TerrainMode } from "./types";

export const initialState: IUpsertMissionInitialState = {
  waypoints: [],
  hoveredDrone: null,
  selectedDrone: null,
  editableRoute: false,
  routeModified: false,
  terrainMode: TerrainMode.RELATIVE,
  activeStep: MissionStep.FLIGHT_DETAILS,
  expandedStep: MissionStep.FLIGHT_DETAILS,
  wizardOrderId: null,
};